import { createSlice } from '@reduxjs/toolkit';
import { fetchTestimonyProgram } from './Utils/TestimonyProgramUtils';

const testimonyProgramSlice = createSlice({
  name: 'TestimonyProgram',
  initialState: {
    filters: {
      'filter[id]': '',
      'filter[name]': '',
      'sort': '',
      'include': '',
      'page': 1,
    },
    data: [],
    detail: {},
    isLoading: false,
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setDetail: (state, action) => {
      state.detail = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestimonyProgram.pending, (state) => {
        // Handle loading state
        state.isLoading = true;
      })
      .addCase(fetchTestimonyProgram.fulfilled, (state, action) => {
        // Handle success state
        state.data = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchTestimonyProgram.rejected, (state, action) => {
        // Handle error state
        state.isLoading = false;
        console.log(action.error.message, "error action")
      });
  }
});

export const { setFilters, setData, setDetail } = testimonyProgramSlice.actions;

export default testimonyProgramSlice.reducer;
